'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiError = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _crossFetch = require('cross-fetch');

var _crossFetch2 = _interopRequireDefault(_crossFetch);

var _Token = require('../api/Token');

var _Token2 = _interopRequireDefault(_Token);

var _TokenUtils = require('./TokenUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//=========================================================
// Constants
//=========================================================

// Use isomorphic fetch so we can test in a node environment
/**
 * @file ApiClient.js
 * Class for ApiClient that executes requests
 * @author Ming Cheuk <ming.cheuk@coveinsurance.co.nz>
 * @copyright Copyright Cove Limited 2018. All rights reserved.
 *
 */

//=========================================================
// Imports
//=========================================================

var ApiError = function (_Error) {
  (0, _inherits3.default)(ApiError, _Error);

  function ApiError(statusCode, statusText, message, path, text) {
    (0, _classCallCheck3.default)(this, ApiError);

    var msg = path + ': ';
    msg += statusText ? '' + statusText : '';
    msg += statusText && statusCode ? ' ' : '';
    msg += statusCode ? '(' + statusCode + ')' : '';
    msg += statusText || statusCode ? '. ' : '';
    msg += message;

    var _this = (0, _possibleConstructorReturn3.default)(this, (ApiError.__proto__ || (0, _getPrototypeOf2.default)(ApiError)).call(this, msg));

    _this.name = 'ApiError';
    _this.statusCode = statusCode;
    _this.statusText = statusText;
    _this.text = text;

    if (Error.captureStackTrace) Error.captureStackTrace(_this, ApiError);
    return _this;
  }

  return ApiError;
}(Error);

exports.ApiError = ApiError;

var ApiClient = function () {
  /**
   * Initialises the API client
   * @param {string} host
   * @param {string} path
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, isTokenClient: bool, refreshInterval: number}} auth
   */
  function ApiClient(host, path, environment, auth) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, ApiClient);

    this.host = host;
    this.env = environment;
    this.accessToken = auth ? auth.accessToken : null; // Client access
    this.apiKey = auth ? auth.apiKey : null; // Server access
    this.path = path;

    // Instantiate a token client ONLY if this is not being initialised by the token client
    if (this.apiKey && !auth.isTokenClient) {
      this.tokenClient = new _Token2.default(this.host, this.env, this.apiKey);

      // Get first token if we have apiKey (server side)
      if (!this.accessToken && this.apiKey) {
        this.tokenClient.create('cove-bot').then(function (token) {
          _this2.accessToken = token;
        });

        // Setup refresh timer (only if interval provided)
        if (auth.refreshInterval) {
          this.refreshTimer = setInterval(function () {
            return _this2.refreshToken();
          }, auth.refreshInterval);
        }
      }
    }
  }

  /**
   * Refreshes the token using the API key
   */


  (0, _createClass3.default)(ApiClient, [{
    key: 'refreshToken',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.tokenClient) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.tokenClient.create('cove-bot');

              case 3:
                this.accessToken = _context.sent;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshToken() {
        return _ref.apply(this, arguments);
      }

      return refreshToken;
    }()

    /**
     * Make request to a normal API
     * @param {string}  method
     * @param {string} verb
     * @param {*} params
     * @param {*} body
     */

  }, {
    key: 'fetch',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(method, verb, params, body) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this._fetchPath(method, this.path, verb, params, body));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetch(_x, _x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return fetch;
    }()

    /**
     * Make request to API
     * @private
     * @param {*} options
     * @param {string} path
     * @param {string} verb
     * @param {*} params
     * @param {*} body
     * @param {*} config
     */

  }, {
    key: '_fetchPath',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(method, path, verb, params, body) {
        var config = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        var options, endpoint, url, startTime, res, endTime, result, err;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Set up options to default value
                options = {
                  method: method,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                };

                // Refresh token if necessary

                if (!(this.tokenClient && (!this.accessToken || (0, _TokenUtils.tokenExpired)(this.accessToken)))) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return this.refreshToken();

              case 4:

                // Access Token or API Key
                if (this.accessToken) options.headers['Authorization'] = 'Bearer ' + this.accessToken;
                // Only used for token client
                else if (this.apiKey) options.headers['x-api-key'] = this.apiKey;
                  // If we don't have a token e.g. create customer
                  else options.headers['Authorization'] = 'None';

                // POST body
                if (body) options.body = (0, _stringify2.default)(body);

                // Final URL
                endpoint = this.env + '/' + path + '/' + verb;
                url = this.host + '/' + endpoint;

                if (params) url += '?' + _queryString2.default.stringify(params);

                // Logging
                startTime = new Date().toISOString();

                if (!config.dontLog) console.log(startTime + ' BEGIN API CALL /' + endpoint);

                // Make request
                _context3.next = 13;
                return (0, _crossFetch2.default)(url, options);

              case 13:
                res = _context3.sent;


                // End time
                endTime = new Date().toISOString();

                if (!config.dontLog) console.log(startTime + ' - ' + endTime + ' END API CALL /' + endpoint);

                // Poll async responses to completion or timeout

                if (!(res.status == 202)) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 19;
                return this.poll(res, url);

              case 19:
                res = _context3.sent;

              case 20:
                _context3.next = 22;
                return res.json();

              case 22:
                result = _context3.sent;

                if (!(res.status == 200)) {
                  _context3.next = 27;
                  break;
                }

                return _context3.abrupt('return', result);

              case 27:
                err = new ApiError(res.status, res.statusText, result.error ? result.error : result.message, path + '/' + verb, result.text);
                throw err;

              case 29:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _fetchPath(_x6, _x7, _x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      }

      return _fetchPath;
    }()

    /**
     * Make request to an async polling based api
     * @param {string} method
     * @param {string} verb
     * @param {*} params
     * @param {*} body
     */

  }, {
    key: 'poll',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(res, url) {
        var _this3 = this;

        var syncResult, id, startTime, poller, asyncResult, endTime;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return res.json();

              case 2:
                syncResult = _context6.sent;

                if (!(!syncResult || !syncResult.id)) {
                  _context6.next = 5;
                  break;
                }

                throw new Error('Error calling api at ' + url + ', the api returned a 202 but the result did not include an id for polling [result: ' + (0, _stringify2.default)(syncResult) + ']');

              case 5:
                id = syncResult.id;

                // Logging

                startTime = new Date().toISOString();

                console.log(startTime + ' Begin polling for result from async api call /' + url);
                poller = new PollRateManager();
                _context6.next = 11;
                return new _promise2.default(function (resolve, reject) {
                  var doPoll = function () {
                    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
                      var asyncResult;
                      return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              if (!(new Date().getTime() - startSeconds >= 5 * 60 * 1000)) {
                                _context4.next = 2;
                                break;
                              }

                              throw Error('ApiClient timed out after 5 minutes while polling for results from a call to ' + url);

                            case 2:
                              asyncResult = void 0;
                              _context4.prev = 3;
                              _context4.next = 6;
                              return this._fetchPath('GET', 'response/v1', 'retrieve', {
                                id: id
                              }, undefined, { dontLog: true });

                            case 6:
                              asyncResult = _context4.sent;
                              _context4.next = 18;
                              break;

                            case 9:
                              _context4.prev = 9;
                              _context4.t0 = _context4['catch'](3);

                              if (!(_context4.t0.statusCode == 404 && count404s < 10)) {
                                _context4.next = 17;
                                break;
                              }

                              count404s++;
                              // Keep going
                              poller.nextTimeout(doPoll.bind(this));
                              return _context4.abrupt('return');

                            case 17:
                              return _context4.abrupt('return', reject(_context4.t0));

                            case 18:
                              if (!(asyncResult.status == 'processing' || !asyncResult.statusCode)) {
                                _context4.next = 23;
                                break;
                              }

                              // Keep going
                              poller.nextTimeout(doPoll.bind(this));
                              return _context4.abrupt('return');

                            case 23:
                              return _context4.abrupt('return', resolve(asyncResult));

                            case 24:
                            case 'end':
                              return _context4.stop();
                          }
                        }
                      }, _callee4, this, [[3, 9]]);
                    }));

                    return function doPoll() {
                      return _ref5.apply(this, arguments);
                    };
                  }();

                  // Set initial timeout


                  var startSeconds = new Date().getTime();
                  var count404s = 0;
                  poller.nextTimeout(doPoll.bind(_this3));
                }.bind(this));

              case 11:
                asyncResult = _context6.sent;


                poller.clear();

                // End time
                endTime = new Date().toISOString();

                console.log(startTime + ' - ' + endTime + ' Finished polling for result from async api call /' + url);

                // Unwarp the body from the result so we can treat it like an api fetch result
                return _context6.abrupt('return', {
                  status: asyncResult.statusCode,
                  statusText: asyncResult.status,
                  source: asyncResult.source,
                  json: function () {
                    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                      return _regenerator2.default.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              return _context5.abrupt('return', asyncResult.body);

                            case 1:
                            case 'end':
                              return _context5.stop();
                          }
                        }
                      }, _callee5, _this3);
                    }));

                    function json() {
                      return _ref6.apply(this, arguments);
                    }

                    return json;
                  }(),
                  text: function text() {
                    return (0, _stringify2.default)(asyncResult.body);
                  }
                });

              case 16:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function poll(_x11, _x12) {
        return _ref4.apply(this, arguments);
      }

      return poll;
    }()
  }]);
  return ApiClient;
}();

//500ms before 1st request, then slowly scale for 2s then poll at 1s for 3s, then switch to 2s


exports.default = ApiClient;
var pollingDelays = [500, 100, 200, 300, 400, 500, 750, 1000, 1000, 1000, 2000];

var PollRateManager = function () {
  function PollRateManager() {
    (0, _classCallCheck3.default)(this, PollRateManager);

    this.index = 0;
    this.timers = [];
  }

  (0, _createClass3.default)(PollRateManager, [{
    key: 'clear',
    value: function clear() {
      this.index = 0;
      // Clear all timeouts to stop any accidental future polling
      this.timers.forEach(function (timer) {
        if (timer) clearTimeout(timer);
      });
      this.timers = [];
    }
  }, {
    key: 'nextTimeout',
    value: function nextTimeout(func) {
      this.timers.push(setTimeout(func, pollingDelays[this.index]));
      // Increment index or stay at final delay
      if (this.index < pollingDelays.length - 1) this.index++;
    }
  }]);
  return PollRateManager;
}();